import ReactHtmlParser from 'react-html-parser';
import * as React from 'react';
import PropTypes from 'prop-types';

/**
 * A utility for converting HTML strings into React components. Avoids the use of
 * dangerouslySetInnerHTML and converts standard HTML elements, attributes and
 * inline styles into their React equivalents.
 *
 * [Read more]{@link https://github.com/wrakky/react-html-parser}
 *
 * @param html {String} a well-formed HTML snippet to be converted into React nodes
 * @author Doug Schroeder, Adam Ayres
 */
export default function Raw({ html }) {
  return <React.Fragment>{ReactHtmlParser(html)}</React.Fragment>;
}

Raw.propTypes = {
  /** html markup that wil be parsed and output as a react fragment */
  html: PropTypes.string.isRequired
};
